import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { eFeatures, eUserRole } from '../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { EmailPrefConfirm } from '../../../models/engage-post.model';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { GlobalService } from '../../../services/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { EngagePostService } from '../../../services/engage-post.service';
import { UserService } from '../../../services/user.service';
import { Subject, takeUntil } from 'rxjs';


@Component({
    selector: 'app-eml-pref-confirm',
    templateUrl: './eml-pref-confirm.component.html',
    styleUrls: ['./eml-pref-confirm.component.css']
})

export class EmlPrefConfirmComponent {
    eUserRole = eUserRole;
    showSpinner: boolean = false;
    private encryptedUser: string = '';
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    clpUserData: CLPUser;
    companyData: ClpCompany;
    imgLogo: string;
    message: string;
    private destroy$ = new Subject<void>();

    constructor(
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private _route: ActivatedRoute,
        private _router: Router,
        public soPostService: EngagePostService,
        public fb: FormBuilder,
        private userService: UserService,
        private _globalService: GlobalService,
        public _accountSetupService: AccountSetupService

    ) {
        this._localService.isMenu = false;
    }

    ngOnInit() {
        this.setupPage();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setupPage() {
        let sbOut = ''
        this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(async params => {
            if (params.uid) {
                let strCLPUserID = params.uid
                sbOut = `strCLPUserID: ${strCLPUserID}<br />`
                if (strCLPUserID != '') {
                    await this.setupEmailPrefConfirm(strCLPUserID)

                    sbOut = sbOut + `CLPCompanyID: ${this.clpUserData?.cLPCompanyID}<br />`

                }

                this.message = 'Thank you for updating your email preferences.'
            }
        })
    }

    async setupEmailPrefConfirm(clpUserId) {
        return this.soPostService.setupEmailPrefConfirm(clpUserId)
            .then(async (result: EmailPrefConfirm) => {
                if (!isNullOrUndefined(result)) {
                    let response = UtilityService.clone(result);
                    this.clpUserData = response?.cLPUser
                    this.companyData = response?.cLPCompany;
                }
            }).catch((err: HttpErrorResponse) => {
                this._globalService.error("so-unsub.soUnSubnUnConvertCodeToID", err.message, null);;
                this._utilityService.handleErrorResponse(err);
            });
    }

}
